import {
  Directive, Input, Optional, Host, SkipSelf,
  AfterViewInit, ViewContainerRef, ComponentFactoryResolver, ComponentRef
} from '@angular/core';
import { ControlContainer, FormControl } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MessagesComponent } from './messages.component';
import { ERROR_MESSAGES } from './error-messages';

export function controlPath(name: string, parent: ControlContainer): string[] {
  // tslint:disable-next-line:no-non-null-assertion
  return [...parent.path!, name];
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[matInput]',
  // tslint:disable-next-line: no-host-metadata-property
  host: {
    '(blur)': 'onBlur($event)'
  }
})
export class FormControlDirective implements AfterViewInit {
  @Input()
  formControlName: string;

  @Input() noValidate: boolean;

  @Input()
  formControl: string | FormControl;

  ngAfterViewInit() {
    if (this.control && !this.noValidate) {
      this.control.statusChanges.subscribe(status => {
        if (status === 'INVALID') {
          this.showError();
        } else {
          if (this.ref) {
            this.ref.instance.messages = [];
          }
        }
      });
    }
  }

  get path() {
    return controlPath(this.formControlName, this.parent);
  }

  get control(): FormControl {
    return this.formDirective && this.formDirective.getControl(this);
  }

  get formDirective(): any {
    return this.parent ? this.parent.formDirective : null;
  }

  onBlur($event) {
    this.showError();
  }

  public messages = () => this.getMessages();

  // tslint:disable-next-line: member-ordering
  ref: ComponentRef<MessagesComponent>;
  private movedToSubscript = false;

  constructor(
    // this value might be null, but we union type it as such until
    // this issue is resolved: https://github.com/angular/angular/issues/25544
    @Optional()
    @Host()
    @SkipSelf()
    private parent: ControlContainer,
    private vcr: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private formField: MatFormField
  ) { }

  private getMessages(): string[] {
    const messages = [];
    if (this.control.invalid && (this.control.dirty || this.control.touched)) {
      if (this.control.errors) {
        Object.keys(this.control.errors).forEach(key => {
          const error = ERROR_MESSAGES.find(err => err.error === key);
          if (!error) {
            return;
          }
          messages.push(error.format(this.control.errors[key]));
        });
      }
      return messages;
    }
  }

  private showError() {
    if (this.control && this.formField && !this.noValidate) {
      if (!this.ref) {
        const factory = this.resolver.resolveComponentFactory(MessagesComponent);
        this.ref = this.vcr.createComponent(factory);
      }
      this.ref.instance.messages = this.getMessages();

      // Move o componente de mensagens para a área de subscript do mat-form-field (MDC),
      // para o erro aparecer abaixo do input, como no Material legado.
      if (!this.movedToSubscript) {
        this.moveMessagesToSubscript();
      }
    }
  }

  private moveMessagesToSubscript(): void {
    try {
      const formFieldEl: HTMLElement =
        (this.formField as any)?._elementRef?.nativeElement ||
        (this.vcr.element?.nativeElement as HTMLElement)?.closest('mat-form-field');

      if (!formFieldEl || !this.ref) return;

      const subscript: HTMLElement | null =
        formFieldEl.querySelector('.mat-mdc-form-field-subscript-wrapper') ||
        formFieldEl.querySelector('.mat-form-field-subscript-wrapper');

      if (!subscript) return;

      const hostEl: HTMLElement = this.ref.location.nativeElement as HTMLElement;
      subscript.appendChild(hostEl);
      this.movedToSubscript = true;
    } catch (e) {
      // Se falhar, mantém o comportamento atual (não quebra o form).
      this.movedToSubscript = false;
    }
  }

}
